/**
 * Created by dmitry on 17.06.2025
 */

const StickersBookStartTutorial = function () {
    return new TutorialScenario(StickersBookStartTutorial.NAME, {
        listSteps: StickersBookStartTutorial.listSteps,

        isAvailable: function () {
            return false;
        }
    });
};

StickersBookStartTutorial.listSteps = function () {
    const steps = [
        {
            onStart: function () {
                cleverapps.focusManager.display({
                    focus: "StickersBookCollectionClickTutorial",
                    stack: true,
                    actions: [
                        (f) => {
                            this.releaseFocus = f;

                            cleverapps.focusManager.showControlsWhileFocused("toolbar");

                            const stickersBookItem = cleverapps.toolbar.getItem(ToolbarItem.STICKERS_BOOK.type);

                            cleverapps.forces.create(stickersBookItem.onGetView(), { finger: true, shadow: false }, {
                                importantNodes: [ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), "toolbar")],
                                onSkip: () => cleverapps.tutorial.skip()
                            });

                            cleverapps.tutorial.on("stickers_book_toolbar_item_clicked", f, this);
                        }
                    ]
                });

                cleverapps.tutorial.on("window_shown", () => this.finish(), this);
            },

            onFinish: function () {
                if (this.releaseFocus) {
                    this.releaseFocus();
                }
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const stickersBookWindow = cleverapps.focusManager.currentWindow();

                if (!stickersBookWindow.icons) {
                    this.finish();
                    return;
                }
                cleverapps.focusManager.setEventNodes([]);
                const target = stickersBookWindow.icons[0];

                stickersBookWindow.scroll.scrollTo(stickersBookWindow.icons[stickersBookWindow.icons.length - 1], 0);
                cleverapps.timeouts.setTimeout(() => {
                    stickersBookWindow.scroll.scrollTo(target, 0.5, { callback: this.finish.bind(this) });
                }, 500);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const stickersBookWindow = cleverapps.focusManager.currentWindow();
                const helpButton = stickersBookWindow.helpButton || stickersBookWindow.windowTitle.helpButton;

                this.force = cleverapps.forces.create(helpButton, { finger: true, shadow: false }, {
                    onSkip: () => cleverapps.tutorial.skip()
                });
                cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const stickersBookWindow = cleverapps.focusManager.currentWindow();

                if (!stickersBookWindow.icons) {
                    this.finish();
                    return;
                }

                const target = stickersBookWindow.icons[0];
                target.setPrizeBarTooltipEnabled(false);
                this.force = cleverapps.forces.create(target, { finger: true }, {
                    onSkip: () => cleverapps.tutorial.skip()
                });
                cleverapps.tutorial.on("stickers_collection_icon_clicked", () => {
                    target.setPrizeBarTooltipEnabled(true);
                    this.finish();
                }, this);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        }
    ];

    return steps.map((step) => new TutorialStep(step));
};

StickersBookStartTutorial.NAME = "sticker_book_start_tutorial";
